import { Observable } from 'rxjs';
import { Mail } from '../entity/mail';

export abstract class MailService {
    abstract sendMail(mail: Mail): Observable<Mail>
    abstract getMailByFrom(email: string): Observable<Mail[]>
  
  
}
